import React, { useEffect } from 'react';
import Header from './components/Header';
import Home from './components/Home';
import Platform from './components/Platform';
import Vision from './components/Vision';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import RefundPolicy from './pages/RefundPolicy';
import ContactPage from './pages/ContactPage';
import WebsiteHealthCheck from './pages/WebsiteHealthCheck';
import Connect from './pages/Connect';
import Radar from './pages/Radar';
import NotFound from './pages/NotFound';
import { PAGE_META, setPageMetadata } from './utils/metadata';

const ROUTES = {
  '/privacy': Privacy,
  '/terms': Terms,
  '/refund-policy': RefundPolicy,
  '/contact': ContactPage,
  '/website-health-check': WebsiteHealthCheck,
  '/connect': Connect,
  '/radar': Radar,
};

const normalizePath = (path) => path.length > 1 ? path.replace(/\/+$/, '') : path;

function Homepage() {
  return (
    <>
      <Home />
      <Platform />
      <Vision />
      <Contact />
    </>
  );
}

function App() {
  const path = normalizePath(window.location.pathname);
  const Page = path === '/' ? Homepage : (ROUTES[path] || NotFound);
  const isPrivateRadar = path === '/radar';
  const isConnect = path === '/connect';

  useEffect(() => {
    setPageMetadata(PAGE_META[path] || PAGE_META.notFound);
    window.scrollTo(0, 0);
  }, [path]);

  if (isPrivateRadar) {
    return <Radar />;
  }

  if (isConnect) {
    return (
      <div className="flex min-h-screen flex-col bg-white">
        <main className="flex-1">
          <Page />
        </main>
        <Footer surface="white" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1">
        <Page />
      </main>
      <Footer />
    </div>
  );
}

export default App;
